export enum DealershipCaseStatus {
  OPEN = 'OPEN',
  COMPLETED = 'COMPLETED',
  CASE_CREATION = 'CASE_CREATION',
}
